var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUseCaseBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#F6E7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5195 12C20.6148 12 19.7473 12.3594 19.1076 12.999C18.468 13.6387 18.1086 14.5062 18.1086 15.4109V16.9612H14.0776C12.1938 16.9612 10.6667 18.4883 10.6667 20.3721V32.7752C10.6667 34.659 12.1938 36.186 14.0776 36.186H33.9226C35.8063 36.186 37.3334 34.659 37.3334 32.7752V20.3721C37.3334 18.4883 35.8063 16.9612 33.9226 16.9612H29.8916V15.4109C29.8916 14.5062 29.5322 13.6387 28.8925 12.999C28.2529 12.3594 27.3853 12 26.4807 12H21.5195ZM28.0311 16.9612V15.4109C28.0311 14.9997 27.8677 14.6053 27.577 14.3146C27.2862 14.0238 26.8919 13.8605 26.4807 13.8605H21.5195C21.1083 13.8605 20.7139 14.0238 20.4232 14.3146C20.1324 14.6053 19.9691 14.9997 19.9691 15.4109V16.9612H28.0311ZM19.9691 18.8217H28.0311V34.3256H19.9691V18.8217ZM18.1086 18.8217H14.0776C13.2213 18.8217 12.5272 19.5158 12.5272 20.3721V32.7752C12.5272 33.6314 13.2213 34.3256 14.0776 34.3256H18.1086V18.8217ZM29.8916 34.3256V18.8217H33.9226C34.7788 18.8217 35.473 19.5158 35.473 20.3721V32.7752C35.473 33.6314 34.7788 34.3256 33.9226 34.3256H29.8916Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUseCaseBig);
export default __webpack_public_path__ + "static/media/icon-use-case-big.36ffed70448e743f3dfe8d183fe1f6e2.svg";
export { ForwardRef as ReactComponent };